import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import {
  et3ParseInteger,
  getOnlyDigitsFromString,
  isPositiveNumber
} from "et3-type-guards";
import { fontSizes } from "et3-ui-library";
import { runInAction } from "mobx";

import i18n from "../../constants/i18n";
import { MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED } from "../../constants/input-entries-constants";
import { USER_SEARCH_BY_PLACEHOLDERS } from "../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreSideMenuStore from "../../stores/core/core-side-menu";
import getCoreUIStore from "../../stores/core/core-ui-store";

const SearchBar = withLiteObserverAndTheme<{
  autoFocus?: boolean;
  size?: "small" | "medium";
}>((props) => {
  const { autoFocus, size } = props;
  const { sideBarSearchText, submitSearch } = getCoreSideMenuStore();
  const userID = sideBarSearchText.get();
  const isSearching =
    getCoreUIStore().isPageLoading.get("USER_ADVANCED") === true;

  return (
    <TextField
      size={size ?? "medium"}
      fullWidth
      autoFocus={autoFocus}
      value={isPositiveNumber(userID) ? `${userID}` : ""}
      placeholder={USER_SEARCH_BY_PLACEHOLDERS.userId}
      onChange={({ target }) => {
        const parsedStringValue = getOnlyDigitsFromString(target.value);
        if (parsedStringValue.length < MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED) {
          const parsedIntegerValue = et3ParseInteger(parsedStringValue);
          runInAction(() => sideBarSearchText.set(parsedIntegerValue));
        }
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter" && isPositiveNumber(sideBarSearchText.get())) {
          submitSearch();
        }
      }}
      slotProps={{
        htmlInput: {
          inputMode: "numeric",
          "aria-label": USER_SEARCH_BY_PLACEHOLDERS.userId
        },
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                size={size === "small" ? "small" : "medium"}
                color="primary"
                disabled={isSearching}
                aria-label={i18n.get("SEARCH")}
                onClick={submitSearch}
              >
                {isSearching ? (
                  <CircularProgress size={fontSizes.lg} color="inherit" />
                ) : (
                  <SearchIcon fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  );
});
export default SearchBar;
